const Routes = {
  products: {
      index: '/products',
      post: '/products',
      remove: '/products/remove',
      edit: '/products/edit/::ID::'
  }
};